export const strings = {
  title: 'リアルタイム配信',
  chanelLabel: 'チャネル一覧',
  startWatchingButton: '視聴開始',
  note:
    '※現在開発中の機能です。マシン内の映像がリアルタイムで視聴できるようになります。',
  noData: '-----',
}
